import SCREENS from '@src/SCREENS';

/**
 * Screens displayed in the BottomTab and CentralPane displayed side by side that should not have active
 * focus trap when rendered on a wide screen to allow navigation between them using the keyboard
 */
const WIDE_LAYOUT_INACTIVE_SCREENS: string[] = [
    SCREENS.HOME,
    SCREENS.SETTINGS.ROOT,
    SCREENS.REPORT,
    SCREENS.SETTINGS.PROFILE.ROOT,
    SCREENS.SETTINGS.PREFERENCES.ROOT,
    SCREENS.SETTINGS.SECURITY,
    SCREENS.SETTINGS.WALLET.ROOT,
    SCREENS.SETTINGS.ABOUT,
    SCREENS.SETTINGS.WORKSPACES,
    SCREENS.SETTINGS.SUBSCRIPTION.ROOT,
    SCREENS.WORKSPACE.ACCOUNTING.ROOT,
    SCREENS.WORKSPACE.INITIAL,
    SCREENS.WORKSPACE.PROFILE,
    SCREENS.WORKSPACE.WORKFLOWS,
    SCREENS.WORKSPACE.INVOICES,
    SCREENS.WORKSPACE.MEMBERS,
    SCREENS.WORKSPACE.CATEGORIES,
    SCREENS.WORKSPACE.MORE_FEATURES,
    SCREENS.WORKSPACE.TAGS,
    SCREENS.WORKSPACE.TAXES,
    SCREENS.WORKSPACE.REPORT_FIELDS,
    SCREENS.WORKSPACE.EXPENSIFY_CARD,
    SCREENS.WORKSPACE.COMPANY_CARDS,
    SCREENS.WORKSPACE.DISTANCE_RATES,
    SCREENS.SEARCH.ROOT,
    SCREENS.SETTINGS.TROUBLESHOOT,
    SCREENS.SETTINGS.SAVE_THE_WORLD,
    SCREENS.WORKSPACE.RULES,
    SCREENS.WORKSPACE.PER_DIEM,
];

export default WIDE_LAYOUT_INACTIVE_SCREENS;
